import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TApplicationUserRelation, adaptApplicationUserRelationFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_APPLICATION_USER_RELATION } from '../../backend-paths';


export const applicationUserRelationDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ADMIN_APPLICATION_USER_RELATION}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_APPLICATION_USER_RELATION}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptApplicationUserRelationFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TApplicationUserRelation> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const applicationUserRelationDeleteSlice = createSlice({
	name: 'applicationUserRelationDeleteSlice',
	initialState,
	reducers: {
		clearApplicationUserRelationDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[applicationUserRelationDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[applicationUserRelationDeleteApi.fulfilled.type]: (state, action: PayloadAction<TApplicationUserRelation>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[applicationUserRelationDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useApplicationUserRelationDeleteSelector = () => useAppSelector(state => state[applicationUserRelationDeleteSlice.name]);

export const { clearApplicationUserRelationDelete } = applicationUserRelationDeleteSlice.actions;
